import type { HtmlTransformer } from '@change-corgi/core-react/html';

import { transformDescriptionHtmlForAdjacentLinkNavigation } from './transformDescriptionHtmlForAdjacentLinkNavigation';

export const descriptionAdjacentAnchorsAccessibilityTransformer: HtmlTransformer = {
	transformHtml: transformDescriptionHtmlForAdjacentLinkNavigation,
};
